export { default } from './LinkTabItem';
export * from './LinkTabItem';
